import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES } from '../config/house.config';

const LANG_LABELS: Record<string, string> = { en: 'EN', hu: 'HU', de: 'DE', it: 'IT', fr: 'FR' };

export default function LanguageSwitcher({ className = '' }: { className?: string }) {
  const { i18n } = useTranslation();
  return (
    <div className={`flex items-center gap-1 ${className}`}>
      {SUPPORTED_LANGUAGES.map(l => (
        <button
          key={l}
          onClick={() => { i18n.changeLanguage(l); localStorage.setItem('ah_language', l); }}
          className={`px-1.5 py-0.5 text-[10px] tracking-widest uppercase font-sans transition-colors ${i18n.language === l ? 'text-charcoal border-b border-charcoal' : 'text-charcoal/30 hover:text-charcoal/60'}`}
        >
          {LANG_LABELS[l]}
        </button>
      ))}
    </div>
  );
}
